import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import ImpersonationBanner from "@/components/ImpersonationBanner";
import PlanGate from "@/components/PlanGate";
import Auth from "@/pages/Auth";
import Home from "@/pages/Home";
import Studio from "@/pages/Studio";
import AstroStudio from "@/pages/AstroStudio";
import Feed from "@/components/Feed";
import Wallet from "@/pages/Wallet";
import Profile from "@/pages/Profile";
import Notifications from "@/pages/Notifications";
import Messages from "@/pages/Messages";
import Pricing from "@/pages/Pricing";
import Admin from "@/pages/Admin";
import Settings from "@/pages/Settings";
import TemplateDetails from "@/pages/TemplateDetails";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-ink-950">
        <div className="label-mono animate-pulse">Loading studio…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function Root() {
  const { user, loading } = useAuth();
  if (loading || user === null) return <div className="min-h-screen bg-ink-950" />;
  return user ? <Navigate to="/home" replace /> : <Home />;
}

function App() {
  return (
    <div className="App bg-ink-950 min-h-screen">
      <AuthProvider>
        <BrowserRouter>
          <ImpersonationBanner />
          <PlanGate />
          <Routes>
              <Route path="/" element={<Root />} />
              <Route path="/login" element={<Auth />} />
              <Route path="/home" element={<Protected><Feed /></Protected>} />
              <Route path="/discover" element={<Protected><Home /></Protected>} />
              <Route path="/wallet" element={<Protected><Wallet /></Protected>} />
              <Route path="/profile" element={<Protected><Profile /></Protected>} />
              <Route path="/u/:uid" element={<Protected><Profile /></Protected>} />
              <Route path="/notifications" element={<Protected><Notifications /></Protected>} />
              <Route path="/messages" element={<Protected><Messages /></Protected>} />
              <Route path="/creations" element={<Navigate to="/profile?tab=folder" replace />} />
              <Route path="/dashboard" element={<Navigate to="/profile?tab=folder" replace />} />
              <Route path="/studio/:projectId" element={<Protected><Studio /></Protected>} />
              <Route path="/astro/:projectId" element={<Protected><AstroStudio /></Protected>} />
              <Route path="/pricing" element={<Protected><Pricing /></Protected>} />
              <Route path="/settings" element={<Protected><Settings /></Protected>} />
              <Route path="/admin" element={<Protected><Admin /></Protected>} />
              <Route path="/t/:id" element={<TemplateDetails />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
        </BrowserRouter>
        <Toaster position="top-right" theme="dark" />
      </AuthProvider>
    </div>
  );
}

export default App;
